import React from 'react';
import './styles.scss';

const MemberShipDeleteButton = (props) => {
  return (
    <button className="icon-button" onClick={props.handleBox}>
     <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M16.1846 8.37402H3.81535C3.43408 8.37402 3.125 8.6831 3.125 9.06437V18.9337C3.125 19.3149 3.43408 19.624 3.81535 19.624H16.1846C16.5659 19.624 16.875 19.3149 16.875 18.9337V9.06437C16.875 8.6831 16.5659 8.37402 16.1846 8.37402Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
         <path d="M5.625 8.37402V5.24902V5.24902C5.625 2.83278 7.58375 0.874023 10 0.874023C12.4162 0.874023 14.375 2.83277 14.375 5.24902V5.24902V8.37402" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
         <path d="M10 15.874C11.0355 15.874 11.875 15.0346 11.875 13.999C11.875 12.9635 11.0355 12.124 10 12.124C8.96447 12.124 8.125 12.9635 8.125 13.999C8.125 15.0346 8.96447 15.874 10 15.874Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
     </svg>
     <span className="button-text sans-font">Delete myLQA Membership</span>
    </button>
  );
};

export default MemberShipDeleteButton;
